export default __webpack_public_path__ + "images/c37dec366b95161813a342ad76c10165.png";